<template>
  <div class="tw-h-full">
    <div
      class="tw-h-[50px] tw-w-full tw-relative tw-z-10 tw-bg-white tw-border-b tw-border-solid tw-border-gray-200 tw-flex tw-items-center tw-justify-between tw-px-4">
      <h2 class="tw-font-semibold tw-text-lg">{{ $t('pages.dashboard.followup_overview') }}</h2>
      <div>
        <a-button @click="show.filters = !show.filters" intent="simple" class="tw-py-0 !tw-min-h-[30px] "
          left-icon="lucide:list-filter">
          <span>{{ $t('buttons.filter') }}</span>
        </a-button>
      </div>
    </div>

    <div :class="[show.filters ? 'tw-grid-rows-[1fr]' : 'tw-grid-rows-[0fr]']"
      class="tw-grid tw-duration-300 tw-transition-all">
      <div class="tw-overflow-hidden tw-col-span-1">
        <div
          class="tw-h-[200px]x tw-bg-white tw-w-full -tw-translate-y-1 tw-border-b tw-border-solid tw-border-gray-200">
        </div>
      </div>
    </div>

    <div class="tw-p-2 tw-grid tw-grid-cols-12 tw-gap-2">
      <div class="tw-col-span-12">
        <FollowupPerformanceWidget />
      </div>
      <div class="tw-col-span-12 md:tw-col-span-6">
        <ReconfirmationChart />
      </div>
      <div class="tw-col-span-12 md:tw-col-span-6">
        <DeliveryChart />
      </div>
      <div class="tw-col-span-12 md:tw-col-span-6">
        <DailyTreatedFollowupsChart />
      </div>
      <div class="tw-col-span-12 md:tw-col-span-6">
        <DailyReconfirmedFollowupsChart />
      </div>
      <div class="tw-col-span-12 md:tw-col-span-6">
        <DailyFollowupCallsChart />
      </div>
      <div class="tw-col-span-12 md:tw-col-span-6">
        <DailyAssignedFollowupsChart />
      </div>
      <div class="tw-col-span-12">
        <TopProductsWidget />
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, provide } from 'vue';
import FollowupPerformanceWidget from '@/components/dashboard/followup/FollowupPerformanceWidget.vue';
import DailyTreatedFollowupsChart from '@/components/dashboard/followup/charts/DailyTreatedFollowupsChart.vue';
import DailyReconfirmedFollowupsChart from '@/components/dashboard/followup/charts/DailyReconfirmedFollowupsChart.vue';
import DailyFollowupCallsChart from '@/components/dashboard/followup/charts/DailyFollowupCallsChart.vue';
import DailyAssignedFollowupsChart from '@/components/dashboard/followup/charts/DailyAssignedFollowupsChart.vue';
import TopProductsWidget from '@/components/dashboard/followup/TopProductsWidget.vue';
import ReconfirmationChart from '@/components/dashboard/followup/charts/ReconfirmationChart.vue';
import DeliveryChart from '@/components/dashboard/followup/charts/DeliveryChart.vue';
import { useAuthStore } from '@/stores';

const authStore = useAuthStore();
const show = ref({ filters: false });
const filters = ref({ user_id: [ authStore.user.id ] });


provide('filters', filters);
provide('filter', () => null);
</script>

<style></style>
  